document.querySelectorAll( 'form[name="wf-form-Filter"]' ).forEach(filterForm => {
  if( filterForm !== null ) {
    const filterFormOnSubmit = event => {
      // filter number inputs
      filterForm.querySelectorAll( 'input[type="number"]' ).forEach( element => {
        if( !element.value  )
          element.setAttribute( 'disabled', 'disabled' );
      } );
      // filter search inputs
      filterForm.querySelectorAll( 'input[type="search"]' ).forEach( element => {
        if( !element.value  )
          element.setAttribute( 'disabled', 'disabled' );
      } );
      // filter select
      filterForm.querySelectorAll( 'select' ).forEach( element => {
        if( !element.options[ element.selectedIndex ].value )
          element.options[ element.selectedIndex ].setAttribute( 'disabled', 'disabled' );
      } )
      filterForm.submit();
    }
    filterForm.addEventListener( 'submit', filterFormOnSubmit );

    // properties filter sort by order
    let orderSelect = document.querySelectorAll( '[name="order-select"]' );
    if( orderSelect !== null ) {
      const orderSelectOnChangeListener = event => {
        const selectedValue = event.target.value;
        let hiddenOrderInput = filterForm.querySelector( '[name="or"]' );
        if( hiddenOrderInput !== null ) {
          hiddenOrderInput.value = selectedValue;
          filterFormOnSubmit();
        }
      }
      orderSelect.forEach( select => select.addEventListener( 'change', orderSelectOnChangeListener ) );
    }
  }
});
// contact form
let contactAgentSelector = document.querySelector( '.contact-agent-header' );
if( contactAgentSelector !== null ) {
  let agentSelector = contactAgentSelector.querySelector( 'select' );
  if( agentSelector !== null ) {
    const retrieveSelectedAgentInfo = () => {
      let selectedOption = agentSelector.options[ agentSelector.selectedIndex ];
      if( !selectedOption.hasAttribute( 'agent-id' ) )
        return {};
      return {
        agent: selectedOption.getAttribute( 'agent-id' ),
        email: selectedOption.value
      }
    }
    // init contact form
    const updateContactFormAgentFields = () => {
      // retrieve form
      let contactForm = document.querySelector( '.wpcf7-form' );
      if( contactForm === null )
        return;
      const selectedAgentInfo = retrieveSelectedAgentInfo();
      if( Object.keys( selectedAgentInfo ).length === 0 )
        return;
      // update agent Email
      let contactFormAgentEmail = contactForm.querySelector( `[name="agent-email"]` );
      if( contactFormAgentEmail !== null )
        contactFormAgentEmail.value = selectedAgentInfo.email;
      // update current image
      let agentAvatars = contactAgentSelector.querySelectorAll( '.contact-agent-selector img[agent-id]' );
      if( agentAvatars !== null ) {
        agentAvatars.forEach( image => {
          if( selectedAgentInfo.agent !== image.getAttribute( 'agent-id' ) && image.classList.contains( 'active' ) )
            image.classList.remove( 'active' );
          if( selectedAgentInfo.agent === image.getAttribute( 'agent-id' ) && !image.classList.contains( 'active' ) )
            image.classList.add( 'active' );
        } )
      }
    }
    updateContactFormAgentFields();
    // set url of property
    ( () => {
      let contactForm = document.querySelector( '.wpcf7-form' );
      if( contactForm === null )
        return;
      let contactFormAgentProperty = contactForm.querySelector( `[name="contact-property"]` );
      if( contactFormAgentProperty === null )
        return;
      contactFormAgentProperty.value = `${window.location.origin}${window.location.pathname}`;
    } )()
    agentSelector.addEventListener( 'change', updateContactFormAgentFields );
  }
  // datepicker
  const datepicker = require( 'js-datepicker' );
  let currentDate = new Date();
  let agentDatePickerOptions = {
    minDate: currentDate
  };
  if( siteCurrentLanguage !== undefined ) {
    switch( siteCurrentLanguage ) {
      case 'es_MX':
        agentDatePickerOptions.customMonths = [ 'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre' ];
        agentDatePickerOptions.customDays = [ 'dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab' ];
        agentDatePickerOptions.overlayButton = 'Ir';
        agentDatePickerOptions.overlayPlaceholder = 'Ingresa año a 4 digitos.';
        agentDatePickerOptions.formatter =  ( input, date, instance ) => {
          input.value = new Intl.DateTimeFormat( siteCurrentLanguage.replace( '_', '-', siteCurrentLanguage ) ).format( date )
        }
        break;
      default:
        agentDatePickerOptions.customMonths = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
        agentDatePickerOptions.customDays = [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ];
        agentDatePickerOptions.overlayButton = 'Go';
        agentDatePickerOptions.overlayPlaceholder = 'Input 4 digit year.';
        agentDatePickerOptions.formatter =  ( input, date, instance ) => {
          input.value = new Intl.DateTimeFormat( 'en-US' ).format( date )
        }
        break;
    }
  }
  let agentDatePicker = datepicker( '[name="contact-date"]', agentDatePickerOptions );
}